var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIceCream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.93639C5.44772 7.93639 5 8.37935 5 8.92578C5 9.47221 5.44772 9.91518 6 9.91518H18C18.5523 9.91518 19 9.47221 19 8.92578C19 8.37935 18.5523 7.93639 18 7.93639H6Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.18903 6.45229C6.85509 3.89189 9.20424 2 12 2C14.7958 2 17.1449 3.89189 17.811 6.45229H6.18903Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19232 11.3993H16.8077L12.9333 21.3658C12.6046 22.2114 11.3954 22.2114 11.0667 21.3658L7.19232 11.3993Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIceCream);
export default __webpack_public_path__ + "static/media/ice-cream.06b1eb9cccef1de53ee622086ef1dded.svg";
export { ForwardRef as ReactComponent };